// AdChoices glyph (Figma "Vector"): the exact 11px AdChoices SVG, kept here in
// the style file and rendered as a CSS background-image (data URI) so the markup
// stays clean. encodeURIComponent keeps the inline SVG valid inside url(...).
const AD_CHOICES_ICON_SVG = "<svg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 11 11' fill='none'><path opacity='0.53' d='M0.873798 0.000104828C1.40633 0.000104781 1.77915 0.25274 2.15196 0.454357C2.4714 0.605775 2.79126 0.807801 3.16408 0.959219C4.86844 1.81752 6.5728 2.72644 8.27674 3.63535C8.80927 3.88798 9.50152 4.14021 9.87433 4.59487C9.98067 4.74629 10.1408 4.94831 10.0874 5.20095C9.92772 5.75642 9.18209 5.95845 8.70294 6.21067C7.5311 6.81675 6.30632 7.47303 5.13449 8.0787C4.70829 8.33133 4.06943 8.78559 3.53689 8.43214C3.32379 8.33133 3.21746 8.23012 3.16408 8.0787C3.11069 7.87667 3.16408 7.62445 3.16408 7.42242L3.16408 5.80662C3.16408 5.35237 3.11069 4.99892 3.43056 4.7969C3.53689 4.74629 3.74999 4.69609 3.90971 4.74629C4.44224 4.94831 4.28253 5.85723 4.28253 6.56412L4.28253 7.11918C5.18787 6.66492 6.09322 6.21026 6.99857 5.80662C7.31801 5.6552 7.85054 5.50378 7.9573 5.09973C8.06364 4.64548 7.05195 4.29204 6.73252 4.14021L3.05774 2.17097C2.79126 2.01955 2.09901 1.51469 1.67324 1.66611C1.51353 1.71671 1.40676 1.86813 1.40676 1.96894C1.35338 2.17097 1.35338 2.4738 1.35338 2.72644L1.35338 4.34224L1.35338 7.06857C1.35338 7.47262 1.3 7.97748 1.45971 8.22971C1.83253 8.73457 2.6845 7.82566 2.95098 8.63376C3.00436 8.83579 2.8976 9.03781 2.79126 9.13862C2.57816 9.44187 1.61943 9.89612 1.24661 9.99734C1.14028 10.0475 0.873798 10.0981 0.714082 10.0981C-0.191267 9.94673 0.0218318 8.58356 0.0218317 7.57343L0.0218313 2.57502C0.0218312 1.81752 -0.0845032 0.8078 0.23493 0.353548C0.394647 0.100913 0.554364 0.100914 0.873798 0.000104828ZM3.64323 3.28191C4.44224 3.28191 4.49519 4.24143 3.74956 4.39285C3.32336 4.44345 3.00393 4.0394 3.11026 3.68596C3.21703 3.43332 3.37675 3.38271 3.64323 3.28191Z' fill='#616161'/></svg>";
const AD_CHOICES_ICON_URL = `url("data:image/svg+xml,${encodeURIComponent(AD_CHOICES_ICON_SVG)}")`;

// --- Base (non device-frame) styles ------------------------------------------
const BASE_STYLES = {
  placementCard: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  videoPlayerVertical: {
    height: '520px',
    width: '300px',
    padding: '10px',
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  videoPlayerRoot: {
    height: '100%',
    width: '100%',
    display: 'flex',
    padding: '20px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  // Empty-state "template" player shown before a video is selected: a black
  // 16:9 box that hosts the shared ClipchampPlayer rendered with an empty
  // videoUrl (its native <video controls> fallback), so the browser paints its
  // default player chrome (play / 0:00 / volume / fullscreen) as a preview of
  // what the video ad slot will look like. The fill rules stretch that native
  // <video> to fill the 16:9 box (mirrors buildVideoFillRules, inlined here
  // because that helper is declared later in this module).
  emptyPlayer: {
    width: '100%',
    maxWidth: '480px',
    margin: '12px auto',
    aspectRatio: '16 / 9',
    backgroundColor: '#000',
    borderRadius: '4px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .video-preview-container': { width: '100%', height: '100%' },
    '& .html-video-player': { width: '100% !important', height: '100% !important' },
    '& video': {
      width: '100% !important',
      height: '100% !important',
      maxHeight: 'none !important',
      objectFit: 'contain !important',
    },
  },
  deviceColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  // Video-partners slot: plain centered ClipchampPlayer, no frame / overlay.
  plainVideo: {
    width: '94%',
    maxWidth: '480px',
    margin: '12px auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

// Shared rules that force the embedded ClipchampPlayer (mp4 <video> or clipchamp
// <Player>) to fill its screen box instead of driving the box height by its own
// intrinsic aspect ratio. Combined with a fixed aspect-ratio screen this keeps a
// vertical (9:16) video from ballooning a 16:9 frame. `!important` is required to
// beat the player's inline `height:auto` / `max-height:450px` styles.
//   - objectFit 'cover'  -> fill the screen edge-to-edge (no letterbox bars),
//                           cropping any aspect mismatch. Used by the landscape
//                           frames (inline / mobileLandscape).
//   - objectFit 'contain'-> letterbox to show the whole video. Used by the
//                           portrait phone so a landscape video isn't cropped.
const buildVideoFillRules = (objectFit = 'contain') => ({
  '& .video-preview-container': { width: '100%', height: '100%' },
  '& .html-video-player': { width: '100% !important', height: '100% !important' },
  '& .clipchamp-video-player': { width: '100% !important', height: '100% !important' },
  '& video': {
    width: '100% !important',
    height: '100% !important',
    maxHeight: 'none !important',
    objectFit: `${objectFit} !important`,
  },
});

// --- MSN video template (Figma "Player / Core / XANDR Ad / Desktop") ---------
// Shared by all four MSN-family slots (Watch / Computer / Smartphone / Play):
// a 16:9 (511x286) ad — solid #616161 player body, the video filling the
// screen, with a "Sponsored" label, a CTA button and an AdChoices corner overlay.
const MSN_STYLES = {
  msnColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  msnFrame: {
    position: 'relative',
    width: '94%',
    maxWidth: '480px',
    margin: '12px auto',
    backgroundColor: '#616161',
    boxSizing: 'border-box',
    display: 'flex',
  },
  msnScreen: {
    position: 'relative',
    width: '100%',
    aspectRatio: '511 / 286',
    backgroundColor: '#000',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...buildVideoFillRules('cover'),
  },
  msnTopGradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '32%',
    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0) 100%)',
    pointerEvents: 'none',
  },
  msnSponsored: {
    position: 'absolute',
    bottom: '32%',
    left: '3%',
    color: '#FFFFFF',
    fontSize: '7.68px',
    lineHeight: '10.24px',
    fontFamily: "'Segoe UI', sans-serif",
    pointerEvents: 'none',
  },
  msnAdChoices: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '17px',
    height: '17px',
    backgroundColor: '#F7F4FB',
    borderRadius: '0 0 0 4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  // AdChoices inner vector (Figma "Vector"): exact 11px AdChoices glyph, rendered
  // from the AD_CHOICES_ICON_URL data URI defined above.
  msnAdChoicesIcon: {
    display: 'block',
    width: '11px',
    height: '11px',
    backgroundImage: AD_CHOICES_ICON_URL,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '11px 11px',
  },
  msnCta: {
    position: 'absolute',
    bottom: '32%',
    right: '3%',
    backgroundColor: '#F7F4FB',
    borderRadius: '4px',
    padding: '5px 12px',
    color: '#616161',
    fontSize: '8.96px',
    fontWeight: '600',
    lineHeight: '12.8px',
    fontFamily: "'Segoe UI', sans-serif",
    whiteSpace: 'nowrap',
    maxWidth: '45%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    pointerEvents: 'none',
  },
};

// --- Device-frame style config (parameterized for reuse) ---------------------
// Each video device frame is defined here as data instead of inline styles, so
// the full CSS for a placement can be read/reused by:
//   - variant key       -> VIDEO_FRAME_STYLE_CONFIG.inline
//   - class key          -> getVideoFrameStyle('deviceInline')
//   - UC placement type  -> getVideoFrameStyle('UC_Video_Inline')
// Each entry carries the outer `frame` style + the inner `screen` style, plus
// the class names used by the rendered markup. getVideoPlacementStyles() flattens
// these into the react-jss class map the UCVideoPlacement component consumes.
export const VIDEO_FRAME_STYLE_CONFIG = {
  // Inline (Figma "Frame 2147233532"): a 16:9 screen with a thin translucent
  // border. The border lives on the FRAME (not the screen) so the screen's
  // content box stays exactly 16:9 -- a 16:9 video fills with no pillarbars, and
  // object-fit: contain shows a vertical video in full (letterboxed, not cropped).
  inline: {
    frameClass: 'deviceInline',
    screenClass: 'deviceInlineScreen',
    frame: {
      width: '94%',
      maxWidth: '460px',
      margin: '12px auto',
      border: '5px solid rgba(0, 0, 0, 0.3)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    screen: {
      width: '100%',
      aspectRatio: '16 / 9',
      backgroundColor: '#000',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      ...buildVideoFillRules('contain'),
    },
  },
  // Mobile landscape (Figma "IMG_7822", rotated 90deg): solid gray phone body
  // with wide side bezels + thin top/bottom; the 16:9 video fills the height.
  // backgroundClip: padding-box keeps the body fill out from under the border so
  // the translucent rim composites over the (light) card -- making the outer
  // border lighter than the darker #616161 side bezels, per Figma.
  mobileLandscape: {
    frameClass: 'deviceLandscape',
    screenClass: 'deviceLandscapeScreen',
    frame: {
      width: '94%',
      maxWidth: '460px',
      backgroundColor: '#616161',
      backgroundClip: 'padding-box',
      border: '5px solid rgba(0, 0, 0, 0.3)',
      borderRadius: '32px',
      padding: '2px 9%',
      margin: '12px auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    screen: {
      width: '100%',
      aspectRatio: '16 / 9',
      backgroundColor: '#000',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      ...buildVideoFillRules('contain'),
    },
  },
  // Mobile portrait (Figma "image 1205" / "Frame 2147233532"): a complete
  // portrait phone scaled up to fill the preview box while preserving the Figma
  // 124:242 frame ratio and the 118:210 (9:16) screen -- i.e. ~2.4% side bezels
  // and ~6.6% top/bottom bezels of black body, kept proportional at any size.
  mobilePortrait: {
    frameClass: 'devicePortrait',
    screenClass: 'devicePortraitScreen',
    frame: {
      width: '195px',
      height: '380px',
      backgroundColor: '#000',
      borderRadius: '28px',
      margin: '8px auto',
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    screen: {
      width: '95.16%',
      height: '86.78%',
      backgroundColor: '#000',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      ...buildVideoFillRules('contain'),
    },
  },
};

// Maps each UC video placement type to its device-frame variant key.
export const VIDEO_PLACEMENT_TO_VARIANT = {
  UC_Video_Inline: 'inline',
  UC_Video_MobileLandscape: 'mobileLandscape',
  UC_Video_MobilePortrait: 'mobilePortrait',
} as const;

// Read a frame's full style config (frameClass/screenClass/frame/screen) by
// variant key, class key, or UC placement type. Returns null if not found.

export const getVideoFrameStyle = (key: string) => {
  if (key in VIDEO_FRAME_STYLE_CONFIG) {
    return VIDEO_FRAME_STYLE_CONFIG[key as keyof typeof VIDEO_FRAME_STYLE_CONFIG];
  }

  const variant = key in VIDEO_PLACEMENT_TO_VARIANT
    ? VIDEO_PLACEMENT_TO_VARIANT[key as keyof typeof VIDEO_PLACEMENT_TO_VARIANT]
    : undefined;
  if (variant) {
    return VIDEO_FRAME_STYLE_CONFIG[variant];
  }
  const match = Object.values(VIDEO_FRAME_STYLE_CONFIG)
    .find(config => config.frameClass === key || config.screenClass === key);
  return match || null;
};

// --- MSN video template lookup (parameterized for reuse) ---------------------
// All four MSN-family slots (Watch / Computer / Smartphone / Play) share the
// same XANDR template today, so they all resolve to MSN_STYLES.
export const MSN_VIDEO_PLACEMENT_TO_TEMPLATE = {
  UC_Video_MSNWatch: 'msn',
  UC_Video_MSNComputer: 'msn',
  UC_Video_MSNSmartphone: 'msn',
  UC_Video_MSNPlay: 'msn',
} as const;

// MSN video templates keyed by template name -> the full class->style map.
export const MSN_VIDEO_TEMPLATE_CONFIG = {
  msn: MSN_STYLES,
};

// Read the full MSN video template CSS (class name -> style object) by MSN
// placement type (e.g. 'UC_Video_MSNComputer') or template key ('msn').
// All four MSN slots return the same template for now. Returns null if not found.

export const getMSNVideoPlacementStyle = (key: string) => {
  if (key in MSN_VIDEO_TEMPLATE_CONFIG) {
    return MSN_VIDEO_TEMPLATE_CONFIG[key as keyof typeof MSN_VIDEO_TEMPLATE_CONFIG];
  }

  const template = key in MSN_VIDEO_PLACEMENT_TO_TEMPLATE
    ? MSN_VIDEO_PLACEMENT_TO_TEMPLATE[key as keyof typeof MSN_VIDEO_PLACEMENT_TO_TEMPLATE]
    : undefined;

  return template ? MSN_VIDEO_TEMPLATE_CONFIG[template] : null;
};

// Flatten the base styles + parameterized device-frame config into the flat
// class map react-jss expects (deviceInline, deviceInlineScreen, ...).
export const getVideoPlacementStyles = () => {
  const frameStyles: { [className: string]: object } = {};
  Object.values(VIDEO_FRAME_STYLE_CONFIG).forEach((config) => {
    frameStyles[config.frameClass] = config.frame;

    frameStyles[config.screenClass] = config.screen;
  });
  return { ...BASE_STYLES, ...MSN_STYLES, ...frameStyles };
};
